<h2 mat-dialog-title>{{ data.featureLink.label }}</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field>
      <input matInput
        placeholder="Path"
        [formControl]="form.controls.path">
    </mat-form-field>

    <mat-form-field>
      <input matInput
        placeholder="Shopify Link"
        [formControl]="form.controls.shopifyLink">
    </mat-form-field>

    <mat-checkbox (click)="$event.stopPropagation()"
      [formControl]="form.controls.forceRedirect">
      Force Redirect to Shopify
    </mat-checkbox>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button
    [mat-dialog-close]="undefined">Cancel</button>
  <button mat-raised-button
    color="primary"
    [disabled]="!form.valid"
    (click)="submit()">Submit</button>
</mat-dialog-actions>